export const sendPageview = async (pathname: string) => {
	const client_id = getClientId();

	const payload = {
		client_id,
		events: [
			{
				name: "page_view",
				params: {
					page_location: window.location.href,
					page_path: pathname,
					page_title: document.title,
				},
			},
		],
	};

	await fetch("/api/collect", {
		method: "POST",
		body: JSON.stringify(payload),
	});
};

function getClientId() {
	let clientId = localStorage.getItem("ga_client_id");
	if (!clientId) {
		clientId = `${Math.random()}-${Date.now()}`;
		localStorage.setItem("ga_client_id", clientId);
	}
	return clientId;
}
